import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { LoadingButton } from '@mui/lab';
import { Box, Button, CardContent, DialogTitle, ListItemIcon, Paper } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CommonHelper } from 'src/utils/commonHelper';

const SnapchatAuthorizationModal = (props) => {
  const { t: translate } = useTranslation();
  const [isLoadingOn, setLoadingOn] = useState(false);
  const isCustomDomain = CommonHelper.CustomDomain();
  const isPortalAdmin = CommonHelper.GetBrandInfoFromLocalStorage("is_portal_admin");

  const handleConnect = () => {
    setLoadingOn(true);
    props.handleConnectSnapchat();
  };

  const handleClose = () => {
    props.handleClose();
  };

  return (
    <Dialog 
      onClose={handleClose} 
      aria-labelledby="customized-dialog-title" 
      open
    >
      <DialogTitle id="customized-dialog-title">
        <Typography gutterBottom variant="h4">
          {props.reAuth 
            ? translate('integration.snapchat.reauthenticate_snapchat_account')
            : translate('integration.snapchat.connect_snapchat_account')}
        </Typography>

        {/* {(!isCustomDomain || isPortalAdmin) && (
          <Box display="flex" justifyContent="center" alignItems="center" mt={1}>
            <Button
              variant="outlined"
              startIcon={<YouTubeIcon />}
              onClick={() => window.open('https://www.youtube.com/watch?v=YOUR_SNAPCHAT_TUTORIAL_LINK', '_blank')}
              color="primary"
            >
              {translate('common.tutorial')}
            </Button>
          </Box>
        )} */}
      </DialogTitle>

      <DialogContent dividers>
        <CardContent sx={{ p: { xs: 0, md: 0 }, color: 'grey.800' }}>
          <Typography variant="body1" sx={{ mx: 'auto', fontWeight: 'bold', mb: 2 }}>
            {translate('common.make_sure_completed_steps')}
          </Typography>

          <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 2}}>
            <ListItemIcon>
              <VerifiedUserIcon sx={{ color: 'success.dark', width: 20, height: 20, mt: 0.3 }} />
            </ListItemIcon>
            <Typography variant="body1">
              {translate('integration.snapchat.logged_into_snapchat')}
            </Typography>
          </Paper>

          <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 2,}}>
            <ListItemIcon>
              <VerifiedUserIcon sx={{ color: 'success.dark', width: 20, height: 20, mt: 0.3 }} />
            </ListItemIcon>
            <Typography variant="body1">
              {translate('integration.snapchat.public_profile_created')}
            </Typography>
          </Paper>

          <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 2, }}>
            <ListItemIcon>
              <VerifiedUserIcon sx={{ color: 'success.dark', width: 20, height: 20, mt: 0.3 }} />
            </ListItemIcon>
            <Typography variant="body1">
              {translate('integration.snapchat.snapchat_permissions_valid')}
            </Typography>
          </Paper>

          <Paper sx={{ display: 'flex', alignItems: 'flex-start', }}>
            <ListItemIcon>
              <VerifiedUserIcon sx={{ color: 'success.dark', width: 20, height: 20, mt: 0.3 }} />
            </ListItemIcon>
            <Typography variant="body1">
              {translate('integration.snapchat.maintain_snapchat_permissions')}
            </Typography>
          </Paper>
        </CardContent>
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" color="error" onClick={handleClose}>
          {translate('common.close')}
        </Button>
        <LoadingButton
          variant="contained"
          loading={isLoadingOn}
          autoFocus
          onClick={handleConnect}
        >
          {props.reAuth ? translate('common.reconnect') : translate('common.connect')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default SnapchatAuthorizationModal;